import axios from "axios";
import Cookies from "js-cookie"
// import DisconnectModal from "../../Components/Modal/disconnectModal";
import DisconnectModal from "../../Components/disconnectModal"

let token = Cookies.get("token");
const instance = axios.create({
    baseURL: "https://robot.mobisha.ir/api/",
    // baseURL: "http://localhost:4500/",
    headers: {
        token: token
    }
});
instance.interceptors.response.use((response) => {
    if (!Cookies.get('showTelegramModal')) {
        DisconnectModal("showTelegramModal")
    }
    // if (!Cookies.get('updatePrices')) {
    //     DisconnectModal("updatePrices")
    // }
    if (response.headers.disconnected && JSON.parse(response.headers.disconnected).status && !Cookies.get('disconnectedModalShow')) {
        DisconnectModal("disconnected", JSON.parse(response.headers.disconnected).channelName)
    }
    if (response.headers.endedpackage === "true" && !Cookies.get('expiredModalShow')) {
        DisconnectModal("expiredAccount")
    }
    if (response.headers.endedpackage === "1Day" && !Cookies.get('expiredModalShow')) {
        DisconnectModal("OneDayToExpire")
    }
    return Promise.resolve(response);
}, (error) => {
    return Promise.reject(error);
});

export default instance;

export const serverAddress = "https://robot.mobisha.ir/api/"
// export const serverAddress =  "http://localhost:4500/"